import { Component } from '@angular/core';
@Component({
  selector: 'app',
  templateUrl: './block-template.component.html',
  styleUrls  : ['./block-template.component.scss']
})
export class BlockTemplateComponent {}
